<div class="expenses-form">
    <h1 class="sub-title" id="generalTitle">
        {{ copyService.copies.expenses_form.title }}
    </h1>

    <form class="form row" id="expensesForm" [formGroup]="formGroup">
        <div *ngIf="!this.abreCuentasService.viewOptionMultiProduct" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.expenses_form.label"
                [description]="copyService.copies.expenses_form.span" [msgErr]="copyService.copies.expenses_form.error">
                <input vclInput id="inputValueExpenses" voxelMask="currency" [config]="config"
                    [placeholder]="copyService.copies.expenses_form.placeholder"
                    (change)="reactiveInputChangeExpenses()" (focus)="reactiveOnFocus()" formControlName="expenses" max="999999999999">
            </vcl-form-field>
        <div *ngIf="this.abreCuentasService.haveLoan">
            <vcl-form-field class="margin_top_30" [label]="copyService.copies.expenses_form_payroll_discount.label"
                [description]="copyService.copies.expenses_form_payroll_discount.span"
                [msgErr]="copyService.copies.expenses_form_payroll_discount.error">
                <input vclInput id="inputValueExpenses" voxelMask="currency" [config]="config"
                    [placeholder]="copyService.copies.expenses_form_payroll_discount.placeholder"
                    (change)="reactiveInputChangeExpenses()" (focus)="reactiveOnFocus()"
                    formControlName="expensesdiscount" max="999999999999">
            </vcl-form-field>
        </div>
        </div>
        <div *ngIf="this.abreCuentasService.viewOptionMultiProduct" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.expenses_form_aproximate_value.label"
                [description]="copyService.copies.expenses_form_aproximate_value.span"
                [msgErr]="copyService.copies.expenses_form_aproximate_value.error">
                <input vclInput id="inputValueExpenses" voxelMask="currency" [config]="config"
                    [placeholder]="copyService.copies.expenses_form_aproximate_value.placeholder"
                    (change)="reactiveInputChangeExpenses()" (focus)="reactiveOnFocus()"
                    formControlName="expenses" max="999999999999">
            </vcl-form-field>
        <div *ngIf="this.abreCuentasService.haveLoan">
            <vcl-form-field class="margin_top_30" [label]="copyService.copies.expenses_form_payroll_discount.label"
                [description]="copyService.copies.expenses_form_payroll_discount.span"
                [msgErr]="copyService.copies.expenses_form_payroll_discount.error">
                <input vclInput id="inputValueExpenses" voxelMask="currency" [config]="config"
                    [placeholder]="copyService.copies.expenses_form_payroll_discount.placeholder"
                    (change)="reactiveInputChangeExpenses()" (focus)="reactiveOnFocus()"
                    formControlName="expensesdiscount" max="999999999999">
            </vcl-form-field>
        </div>
        </div>
    </form>
</div>

<app-controls id="formContactInfoBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_contact_btn"
    [nextDisabled]="!formGroup.valid" (next)="next()"></app-controls>